.mappedin-marker {
	font-family: 'InterUI-Regular', Helvetica, Arial, sans-serif;
	font-weight: normal;
	top: 0;
	position: absolute;
	font-weight: bold;
	color: black;
	display: flex;
	flex-direction: row;
	will-change: transform, opacity;
	transition: opacity 150ms ease-in-out;
	justify-content: center;
	opacity: 0;
}

/* Low priority pin strategy styles */

/* Hide child elements as well */
.mappedin-marker[data-anchor="low-priority-pin"]> .mappedin-marker-content {
	visibility: hidden;
}

/* Create the pin using ::before pseudo-element */
.mappedin-marker::before {
	content: '';
	display: none;
	border-radius: 50%;
	position: relative;
	/* Default values - will be overridden by inline styles */
	width: var(--mappedin-pin-size, 2px);
	height: var(--mappedin-pin-size, 2px);
	background-color: var(--pin-color, #666);
}

.mappedin-marker[data-anchor="low-priority-pin"]::before {
	display: block;
}
